import { createFileRoute } from "@tanstack/react-router";
import PartsCatalogCheckout from "@/pages/PartsCatalogCheckout";
import { pageHead } from "@/lib/routeHead";

export const Route = createFileRoute("/parts-catalog/checkout/")({
  head: () => { const h = pageHead({ title: 'Rex & Sons RVs', description: 'Rex & Sons RVs — family-owned RV dealer in Castle Hayne, NC since 1997. Sales, service, parts and rentals.', path: '/parts-catalog/checkout' }); h.meta.push({ name: "robots", content: "noindex, follow" }); return h; },
  component: PartsCatalogCheckout,
});